import FormItem from "@components/formItem";
import { StakeFieldWrapper } from "@pages/profile-v2/pages/deposit/baseItems";
import { BoxWrapper } from "@pages/profile/withdraw/baseItems";
import { getUser } from "@utils";
import React, { Fragment } from "react";
import MaskInput from "react-maskinput";
import { Box, BoxTitle, Content, ContentTitle, MaskedInput, StakeInput } from "../baseItems";
import Base from "./base";
export default class Unlimit extends Base {
	getStep1(translate) {
		const { method } = this.props;
		const {
			stake,
			selectedCurrency,
			crypto_currency,
			crypto_payway,
			doc_type,
			banks,
			cards,
			bank_id,
			bank_code,
			account_type,
			card,
		} = this.state;
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					{this.getCurrencyField(translate)}
					<StakeFieldWrapper>
						<div className="stake-field">{this.getStakeField()}</div>
						<div className="min-max-field">{this.renderMinMax()}</div>
					</StakeFieldWrapper>
				</BoxWrapper>
				<Fragment>
					{method === "UnlimitSPEI" && (
						<FormItem onRegister={() => this.registerField({ name: "account_number" })}>
							<Box small={true}>
								<BoxTitle>{translate("CLABE")}</BoxTitle>
								<MaskedInput>
									<MaskInput
										alwaysShowMask={window.IS_MARS ? true : false}
										maskChar="."
										mask="000000000000000000"
										size={18}
										onChange={this.onEnterValue.bind(this, "account_number")}
									/>
								</MaskedInput>
							</Box>
						</FormItem>
					)}
					{method === "UnlimitPayPal" && (
						<FormItem onRegister={() => this.registerField({ name: "email_address" })}>
							<Box>
								<BoxTitle>{translate("EMAIL_ADDRESS")}</BoxTitle>
								<StakeInput
									placeholder="...................."
									onChange={this.onEnterValue.bind(this, "email_address")}
								/>
							</Box>
						</FormItem>
					)}
					{method === "UnlimitBankCard" && (
						<>
							<FormItem
								onRegister={() => this.registerField({ name: "card_number" })}>
								<Box small={true}>
									<BoxTitle>{translate("CREDIT_CARD")}</BoxTitle>
									<MaskedInput>
										<MaskInput
											alwaysShowMask={window.IS_MARS ? true : false}
											maskChar="."
											mask="0000000000000000"
											size={20}
											onChange={this.onEnterValue.bind(this, "card_number")}
										/>
									</MaskedInput>
								</Box>
							</FormItem>
							<FormItem onRegister={() => this.registerField({ name: "expiration" })}>
								<Box small={true}>
									<BoxTitle>{translate("EXPIRY_DAY")}</BoxTitle>
									<MaskedInput>
										<MaskInput
											alwaysShowMask={window.IS_MARS ? true : false}
											maskChar="."
											mask="00/0000"
											size={6}
											onChange={this.onEnterValue.bind(this, "expiration")}
										/>
									</MaskedInput>
								</Box>
							</FormItem>
						</>
					)}
				</Fragment>
			</Content>
		);
	}

	makeExternalPayment() {
		const { method } = this.props;
		const { stake, selectedCurrency, account_number, card_number, expiration, email_address } =
			this.state;

		let withdrawData = {
			type: "Unlimit",
			method: method.split("Unlimit")[1],
			username: getUser().username,
			sessionId: getUser().sessionId,
			account_number,
			email_address,
			card_number,
			expiration,
			amount: {
				value: stake,
				currency: selectedCurrency,
			},
			language: this.getActiveLanguageCode(),
			note: new Date(),
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}
}
